module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Hinzufügen","noItemsWereFound":"Es sind keine Einträge vorhanden.","search":"Suchen"},"en":{"add":"Add","noItemsWereFound":"No items were found.","search":"Search"}}')
  delete Component.options._Ctor
}
